import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../components/Layout'

import Form from '../components/Form'

import { Helmet } from 'react-helmet'

const openChat = () => drift.api.sidebar.open()

export default () => (
  <Layout>
    <Helmet>
      <title>Free Website Audit - Online Review - Turboclicks</title>
      <meta
        name="description"
        content="Take advantage of our 100% free, no obligation website review to learn areas your website could improve."
      />
    </Helmet>
    <Box mt={5}>
      <Form
        id="form"
        type="audit"
        title="Get my obligation free website review"
        showMessage={false}
      />
    </Box>
  </Layout>
)
